if (typeof Promise === 'undefined') {
  console.log('Promise is undefined in this browser, polyfilling.')
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}